import * as tslib_1 from "tslib";
import { AbstractPageComponent } from 'src/app/shared/components/abstract-page/abstract-page.component';
var LoginComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LoginComponent, _super);
    function LoginComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultTitle = 'Login page';
        return _this;
    }
    return LoginComponent;
}(AbstractPageComponent));
export { LoginComponent };
